<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.AnalyteWaiOpotikiEstuaryAtKukumoa"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.UaWaiowekaAtCableway"></app-basic-cartesian-chart>
<app-basic-cartesian-chart
  class="hide-check"
  [config]="ChartConfig.AnalyteWaiOpotikiHarbour"
></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.AnalyteWaiOtaraRiver"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.AnalyteWhenuaOmaukora"></app-basic-cartesian-chart>
<app-basic-cartesian-chart class="hide-check" [config]="ChartConfig.TaiaoOpotikiHarbour"></app-basic-cartesian-chart>
